module.exports = __webpack_public_path__ + "img/17.03b69b48.png";